// Shared outreach pipeline definitions for SafeSourcer.
// Order matters: it drives the pipeline overview + sort.

export const STATUSES = [
  'not_contacted',
  'contacted',
  'replied',
  'quote_received',
  'sample_ordered',
  'negotiating',
  'closed',
];

// Tailwind classes per status — calm progression, easy to scan
export const STATUS_BADGE = {
  not_contacted:    'bg-slate-100 text-slate-700 border-slate-200',
  contacted:        'bg-blue-100 text-blue-700 border-blue-200',
  replied:          'bg-cyan-100 text-cyan-700 border-cyan-200',
  quote_received:   'bg-violet-100 text-violet-700 border-violet-200',
  sample_ordered:   'bg-indigo-100 text-indigo-700 border-indigo-200',
  negotiating:      'bg-amber-100 text-amber-700 border-amber-200',
  closed:           'bg-emerald-100 text-emerald-700 border-emerald-200',
};

// Solid dot color for the small indicator on cards
export const STATUS_DOT = {
  not_contacted: 'bg-slate-400',
  contacted: 'bg-blue-500',
  replied: 'bg-cyan-500',
  quote_received: 'bg-violet-500',
  sample_ordered: 'bg-indigo-500',
  negotiating: 'bg-amber-500',
  closed: 'bg-emerald-500',
};

export const isValidStatus = (s) => STATUSES.includes(s);
